import { useCallback } from "react";

export const useEmployeeTime = () => {
  const getTimeRemaining = useCallback((expirationDate?: Date) => {
    if (!expirationDate) {
      return null;
    }

    const now = new Date();
    const expiration = new Date(expirationDate);
    const diffMs = expiration.getTime() - now.getTime();

    if (diffMs <= 0) {
      return { expired: true, text: "" };
    }

    const totalMinutes = Math.floor(diffMs / (1000 * 60));
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;

    let timeText = "";
    if (hours > 0) {
      timeText += `${hours}h `;
    }
    if (minutes > 0 || hours === 0) {
      timeText += `${minutes}m `;
    }
    timeText += "remaining";

    return { expired: false, text: timeText.trim() };
  }, []);

  return { getTimeRemaining };
};
